// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"5889cf884ef40f6f","3151":"18d5feeb0397dbae"}[chunkId] + ".css";
};